import { render } from "./RecentSearches.vue?vue&type=template&id=72bae5ba&scoped=true"
import script from "./RecentSearches.vue?vue&type=script&lang=js"
export * from "./RecentSearches.vue?vue&type=script&lang=js"

import "./RecentSearches.vue?vue&type=style&index=0&id=72bae5ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bae5ba"]])

export default __exports__